import { FormSection } from "./type";

export interface ServiceToggles { transport?: boolean; canteen?: boolean; hostel?: boolean; }



export const buildServicesSection = (toggles: ServiceToggles): FormSection => {
  const subsections: NonNullable<FormSection["subsections"]> = [];


  if (toggles.transport) {
    subsections.push({
      id: "transport-subsection",
      title: "Transport",
      collapsible: true,
      defaultOpen: true,
      columns: 2,
      fields: [
        {
          id: "busRoute", label: "Select Bus Route", type: "select",
          options: ["route 1", "route 2", "route 3"], columns: 1
        },

        {
          id: "pickup", label: "Pick up", type: "select",
          options: ["block 1", "block 2", "block 3"], columns: 1
        },

        {
          id: "busfee", label: "Bus Fees(Yearly)", type: "number",
          isFee: true, columns: 1, readonly: true
        },
      ],
    });
  }

  // 2) Hostel (ON shows: Hostel Fees)
  if (toggles.hostel) {
    subsections.push({
      id: "hostel-subsection",
      title: "Hostel",
      collapsible: true,
      defaultOpen: true,
      columns: 2,
      fields: [
        {
          id: "hostelName",
          label: "Select Hostel",
          type: "select",
          options: ["Ganga", "Indus"],   // the two options
          columns: 1,
        },
        {
          id: "hostelfee",
          label: "Hostel Fees(Yearly)",
          type: "number",
          isFee: true,
          columns: 1,
          readonly: true,                // auto-filled from selection
        },
      ],
    });
  }

  if (toggles.canteen) {
    subsections.push({
      id: "canteen-subsection",
      title: "Canteen",
      collapsible: true,
      defaultOpen: true,
      columns: 2,
      fields: [
        {
          id: "canteenPlan",
          label: "Canteen Plan",
          type: "select",
          options: ["Breakfast-Dinner", "Dinner"],  // user picks plan
          columns: 1,
        },
        {
          id: "canteenfee",
          label: "Canteen Fees(Yearly)",
          type: "number",
          isFee: true,
          columns: 1,
          readonly: true,                            // auto-filled from plan
        },
      ],
    });
  }


  return {
    id: "services",
    title: "Services",
    collapsible: true,
    defaultOpen: true,
    columns: 2,
    fields: [],
    subsections,
  };
};

/**
 * Base form sections
 */
const baseSections: FormSection[] = [
  {
    id: "student-info", title: "Student Information", collapsible: false, columns: 2, fields: [
      { id: "firstName", label: "First Name", type: "text", required: true, placeholder: "Enter First Name", columns: 1 },
      { id: "middleName", label: "Middle Name", type: "text", placeholder: "Enter Middle Name", columns: 1 },
      { id: "lastName", label: "Last Name", type: "text", required: true, placeholder: "Enter Last Name", columns: 1 },
      { id: "dateOfBirth", label: "Date of Birth", type: "date", required: true, columns: 1 },
      { id: "gender", label: "Gender", type: "select", required: true, options: ["Male", "Female", "Other"], columns: 1 },
      { id: "bloodGroup", label: "Blood Group", type: "select", options: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"], columns: 1 },
      { id: "mobileNo", label: "Mobile No.", type: "tel", placeholder: "+91xxxxxxxxxx", required: true, columns: 1 },
      { id: "email", label: "Email ID", type: "email", placeholder: "Enter email address", columns: 1 },
    ]
  },

  {
    id: "father-info", title: "Father Information", collapsible: false, defaultOpen: true, columns: 2, fields: [
      { id: "fathersName", label: "Name", type: "text", required: true, placeholder: "Enter Father's Name", columns: 1 },
      { id: "fatherLast", label: "Last Name", type: "text", required: true, placeholder: "Enter Last Name", columns: 1 },
      { id: "fatherEmail", label: "Email ID", type: "email", required: true, placeholder: "Enter email address", columns: 1 },
      { id: "fatherOccupation", label: "Occupation", type: "select", options: ["Private", "Government", "Business", "Retired", "Other"], columns: 1 },
      { id: "fatherWorkPlaceDetail", label: "Work Place Detail", type: "text", placeholder: "Enter Detail", columns: 1 },
    ]
  },

  {
    id: "mother-info", title: "Mother Information", collapsible: false, defaultOpen: true, columns: 2, fields: [
      { id: "motherName", label: "Name", type: "text", required: true, placeholder: "Enter Mother's Name", columns: 1 },
      { id: "motherLast", label: "Last Name", type: "text", required: true, placeholder: "Enter Last Name", columns: 1 },
      { id: "motherEmail", label: "Email ID", type: "email", required: true, placeholder: "Enter email address", columns: 1 },
      { id: "motherOccupation", label: "Occupation", type: "select", options: ["Homemaker", "Private", "Government", "Business", "Retired", "Other"], columns: 1 },
      { id: "motherWorkPlaceDetail", label: "Work Place Detail", type: "text", placeholder: "Enter Detail", columns: 1 },
    ]
  },

  {
    id: "sibling-info", title: "Sibling Information (If Any)", collapsible: true, defaultOpen: true, columns: 2, fields: [
      { id: "siblingName", label: "Name", type: "text", placeholder: "Enter Sibling's Name", columns: 1 },
      { id: "siblingEmail", label: "Email ID", type: "email", placeholder: "Enter email address", columns: 1 },
    ]
  },

  {
    id: "address-contact", title: "Address and Contact Details", collapsible: false, defaultOpen: true, columns: 2, fields: [
      { id: "address1", label: "Address Line 1", type: "text", columns: 1 },
      { id: "address2", label: "Address Line 2", type: "text", columns: 1 },
      { id: "state", label: "State", type: "text", columns: 1 },
      { id: "country", label: "Country", type: "text", columns: 1 },
      { id: "pincode", label: "Pin Code", type: "text", columns: 1 },
    ]
  },

  {
    id: "emergency-contact", title: "Emergency Contact Details", collapsible: false, defaultOpen: true, columns: 2, fields: [
      { id: "emergencyContactName", label: "Contact Name", type: "text", required: true, columns: 1 },
      { id: "emergencyContactNumber", label: "Mobile No.", type: "tel", required: true, columns: 1 },
    ]
  },



  {
    id: "education-info", title: "Education Information", collapsible: true, defaultOpen: true, columns: 2, fields: [
      { id: "previousInstitution", label: "Previous Institution", type: "text", required: true, columns: 1 },
      { id: "previousInstitutionAddress", label: "Institution Address", type: "text", columns: 1 },
      { id: "languageOfInstruction", label: "Language of Instruction", type: "text", columns: 1 },
      { id: "specialEducationNeeds", label: "Special Educational Needs", type: "text", columns: 1 },
    ]
  },

  {
    id: "other-info", title: "Other Information", collapsible: true, defaultOpen: true, columns: 2, fields: [
      { id: "referralSource", label: "Referral Source", type: "text", columns: 1 },
      { id: "nativeLanguage", label: "Native Language", type: "text", columns: 1 },
      { id: "additionalInfo", label: "Additional Info", type: "textarea", columns: 2 },
      { id: "healthCondition", label: "Health Issue (if any)", type: "textarea", columns: 2 },
      { id: "comments", label: "Comments", type: "text", columns: 2 },
      // { id: "consentToDataProcessing", label: "Consent To Data Processing", type: "checkbox", columns: 2 },

    ]
  },
];

/**
 * Build the full admission form configuration dynamically
 */
export const buildAdmissionFormConfig = (toggles: ServiceToggles = {}): FormSection[] => {
  const config: FormSection[] = [...baseSections];

  // Services section
  config.push(buildServicesSection(toggles));

  config.push({
    id: "fees-summary",
    title: "Fees Summary",
    collapsible: false,
    defaultOpen: true,
    columns: 2,
    fields: [
      {
        id: "courseFees",
        label: "Course Fees / Year",
        type: "number",
        readonly: true,
        columns: 1
      },
      {
        id: "additionalFeesPerMonth",
        label: "Additional Fees (Yearly)",
        type: "number",
        readonly: true,
        columns: 1
      },
      {
        id: "totalFeesPerMonth",
        label: "Monthly Fees(INR)",
        type: "number",
        readonly: true,
        columns: 1
      },
      {
        id: "totalFeesPerYear",
        label: "Yearly Fees(INR)",
        type: "number",
        readonly: true,
        columns: 1
      },
    ]
  });


  // Documents section
  config.push({
    id: "documents", title: "Required Documents", collapsible: true, defaultOpen: true, columns: 2, fields: [
      { id: "tenthMarksheet", label: "10th Marksheet / Certificate", type: "file", accept: ".pdf,.jpg,.png", required: true, columns: 1 },
      { id: "twelfthMarksheet", label: "12th Marksheet / Certificate", type: "file", accept: ".pdf,.jpg,.png", required: true, columns: 1 },
    ]
  });

  return config;
};
